const latestNavItems = document.querySelectorAll('.left-nav-el')
const latestWrappers = document.querySelectorAll('.right-nav-el')
const latestPlay = document.querySelector('.latest-events__right__content__videos-wrapper__right__video__play')
let LatestIndex = 0

latestNavItems.forEach(function(element) {
    element.addEventListener('click', function() {
        latestNavItems.forEach(function(element) {
            element.classList.remove('active')
        })
        element.classList.add('active')
        latestNavItems.forEach(function(element, i) {
            if (element.classList.contains('active')) {
                LatestIndex = i
            }
        })
        latestWrappers.forEach(function(element) {
            element.classList.add('deum')
        })
        if (latestPlay) {
            latestPlay.classList.remove('deum')
        }
        latestWrappers[LatestIndex].classList.remove('deum');
    })
})

if (latestPlay) {
    latestPlay.addEventListener('click', function() {
        latestPlay.classList.add('deum')
    })
}

const secondaryNav = document.querySelector('.left-nav-sticky')

if (secondaryNav) {
    let scrollTop = 0
    const ScrollSecondaryMenu = function(scrollTop) {
        return function() {
            let clientWidth = document.documentElement.clientWidth

            window.addEventListener('resize', function() {
                clientWidth = document.documentElement.clientWidth
                if (clientWidth > 1200) {
                    secondaryNav.style = 'top: 0px'
                }
            })

            if (clientWidth < 1200) {
                let windowOffset = window.pageYOffset

                if (windowOffset > scrollTop) {
                    secondaryNav.style = 'top: 0px'
                } else {
                    secondaryNav.style = 'top: 63px'
                }
                if (scrollTop <= -1) {
                    secondaryNav.style = 'top: 63px'
                }

                scrollTop = windowOffset
            }
        }
    }
    window.addEventListener('scroll', ScrollSecondaryMenu(scrollTop))
}